import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/404'
import Dashboard from '@/pages/Dashboard'
import WorkJobs from '@/pages/OrderList'
import PlaceOrder from '@/pages/PlaceOrder'
import OrderHistory from '@/pages/OrderHistory'
import AddCredits from '@/pages/AddCredits'
import Parser from '@/pages/Parser'
import API from '@/pages/APISettings'
import Login from '@/components/Login'


Vue.use(Router)

import auth from '@/utils/auth'

function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

// const debug = process.env.NODE_ENV !== 'production'

export default new Router({
  base: __dirname,
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/404', component: ErrorPage, name: 'ErrorPage' },
    { path: '/dashboard', component: Dashboard, name: 'Dashboard', beforeEnter: requireAuth },
    { path: '/orders', component: WorkJobs, name: 'WorkJobs', beforeEnter: requireAuth },
    { path: '/neworder', component: PlaceOrder, name: 'PlaceOrder', beforeEnter: requireAuth },
    { path: '/history', component: OrderHistory, name: 'OrderHistory', beforeEnter: requireAuth },
    { path: '/parser', component: Parser, name: 'Parser', beforeEnter: requireAuth },
    { path: '/credits', component: AddCredits, name: 'AddCredits', beforeEnter: requireAuth },
    { path: '/apisetup', component: API, name: 'API', beforeEnter: requireAuth },
    { path: '/login', component: Login, name: 'Login' },
    { path: '/logout',
      beforeEnter (to, from, next) {
        auth.logout()
        next('/login')
      }
    },
    { path: '/', redirect: '/dashboard' },
    { path: '*', redirect: '/404' }
  ],
  meta: {
    progress: {
      func: [
        {call: 'color', modifier: 'temp', argument: '#ffb000'},
        {call: 'fail', modifier: 'temp', argument: '#6e0000'},
        {call: 'location', modifier: 'temp', argument: 'top'},
        {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.6s', termination: 400}}
      ]
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js